"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var shared_1 = require("mad-utils/lib/shared");
/**************************************** PROJECT MODULES *****************************************/
var javelin_exports_1 = require("../../javelin-exports");
/******************************************** HELPERS *********************************************/
/**
 * Return relationship number from relationship name or number
 */
function getRelationshipNumFromRelationship(rel) {
    if (typeof rel === 'number' && (rel === 0 || rel === 1 || rel === 2 || rel === 3)) {
        return rel;
    }
    else if (typeof rel === 'number') {
        throw new TypeError("Relationship argument must be " +
            "SELF, PARENT_GUARDIAN, PARENT, GUARDIAN, SPOUSE, OTHER, 0, 1, 2, or 3");
    }
    if (typeof rel === 'string') {
        if (rel.toLowerCase() === 'self')
            return 0;
        if (rel.toLowerCase() === 'spouse')
            return 2;
        if (rel.toLowerCase() === 'other')
            return 3;
        if (rel.toLowerCase() === 'parent' ||
            rel.toLowerCase() === 'guardian' ||
            rel.toLowerCase() === 'parent_guardian' ||
            rel.toLowerCase() === 'parentguardian') {
            return 1;
        }
    }
}
exports.getRelationshipNumFromRelationship = getRelationshipNumFromRelationship;
/********************************************* EXPORT *********************************************/
/**
 * Relationship object with types applied (Applies types from constants and exports)
 */
exports.Relationship = javelin_exports_1.javelin.data.model.Relationship;
shared_1.addImmutableMethod(exports.Relationship, 'getRelationshipNumFromRelationship', getRelationshipNumFromRelationship);
shared_1.defineProp(exports.Relationship, 'JVLN_CLASS_NAME', 'Relationship', false);
//# sourceMappingURL=relationship.js.map